import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';

/** 표준 위험요인 목록(DOC-136 §7) — 옛 공종별 위험성평가의 줄을 공종 · 작업 · 위험요인 · 대책으로 묶은 것. */
const BASE = '/v1/safe/risk-library';

export type RiskLibraryTrade = { trade: string; lineCount: number; usedCount: number };

/** 재해형태 · 등급 · 가능성 · 중대성은 그 줄이 쓰인 가장 최근 평가의 값. 옛 가능성 · 중대성은 우리와 같은 1~3. */
export type RiskLibraryLine = {
  trade: string;
  task: string | null;
  hazard: string;
  measure: string | null;
  accidentType?: string | null;
  grade?: string | null;
  likelihood?: number | null;
  severity?: number | null;
  usedCount: number;
  lastUsed?: string | null;
};

export function useRiskLibraryTrades(enabled: boolean) {
  return useQuery({
    queryKey: ['risk-library', 'trades'],
    queryFn: () => apiFetch<RiskLibraryTrade[]>(`${BASE}/trades`),
    enabled,
    staleTime: 10 * 60 * 1000,
  });
}

/** 공종을 골랐으면 그 공종 전부(글 거르기는 화면이), 전체면 서버가 글로 거른다. */
export function useRiskLibraryLines(trade: string | null, q: string) {
  const query = new URLSearchParams();
  if (trade) query.set('trade', trade);
  if (!trade && q) query.set('q', q);
  return useQuery({
    queryKey: ['risk-library', 'lines', trade, trade ? '' : q],
    queryFn: () => apiFetch<RiskLibraryLine[]>(`${BASE}?${query.toString()}`),
    enabled: !!trade || q.length >= 2,
    staleTime: 10 * 60 * 1000,
  });
}
